import React from "react";
import styled from "styled-components";

import { getConfig } from "../../../../../../utils/config";

const config = getConfig();

const colors = config.theme.colors;

const Hr = styled.hr`
  border: none;
  border-top: 1px solid #3c4d5d;
  margin: 20px 0 10px;
  width: 100%;
`;

export default Hr;


// WEBPACK FOOTER //
// ./src/views/AppViews/Sidebar/components/Nav/Hr/index.jsx